import api from "./api";

export async function getMyDocuments(category = "") {
  const params = category ? { category } : undefined;
  const res = await api.get("/documents/mine", { params });
  return {
    documents: Array.isArray(res.data?.documents) ? res.data.documents : [],
    counts: res.data?.counts || { total: 0, shared: 0, workorders: 0, projects: 0 },
  };
}

export async function uploadSharedDocument({ file, title, categorie, important }) {
  const formData = new FormData();
  formData.append("bestand", file);
  if (title) formData.append("title", title);
  if (categorie) formData.append("categorie", categorie);
  if (important !== undefined) formData.append("important", String(Boolean(important)));

  const res = await api.post("/documents/shared", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return res.data;
}

export async function getWorkorderDocuments(workorderId) {
  const res = await api.get(`/documents/workorder/${workorderId}`);
  return {
    sharedDocuments: Array.isArray(res.data?.sharedDocuments) ? res.data.sharedDocuments : [],
    projectDocuments: Array.isArray(res.data?.projectDocuments) ? res.data.projectDocuments : [],
    workorderDocuments: Array.isArray(res.data?.workorderDocuments) ? res.data.workorderDocuments : [],
  };
}
